import { CALL_API } from '@aftonbladet/redux-api-middleware';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';

import {
    PLUSS_ARTICLES_REQUEST,
    PLUSS_ARTICLES_SUCCESS,
    PLUSS_ARTICLES_ADD,
    PLUSS_ARTICLES_FAILURE,
} from './types';

/* eslint-disable import/prefer-default-export */
export const fetchPlussArticlesAction = ({
    force = false,
    offset = 0,
    section = '',
    excludedSections = '',
}) => {
    const { iris: { host } } = config;
    const endpoint = `${host}${
        config.iris.teasers
    }?paywall=true&offset=${offset}&limit=21&section=${section}&excludedSections=${excludedSections}`;

    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            types: [PLUSS_ARTICLES_REQUEST, PLUSS_ARTICLES_SUCCESS, PLUSS_ARTICLES_FAILURE],
            bailout: (state) => !force && !!state.plussArticles.pluss.length,
        },
    };
};
/* eslint-enable import/prefer-default-export */

/* eslint-disable import/prefer-default-export */
export const addPlussArticlesAction = ({ offset = 0, section = '', excludedSections = '' }) => {
    const { iris: { host } } = config;
    const endpoint = `${host}${
        config.iris.teasers
    }?paywall=true&offset=${offset}&limit=21&section=${section}&excludedSections=${excludedSections}`;

    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            types: [PLUSS_ARTICLES_REQUEST, PLUSS_ARTICLES_ADD, PLUSS_ARTICLES_FAILURE],
        },
    };
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/pluss-articles.js
 **/